module.exports = __webpack_public_path__ + "5070afeb25e015ccc82e8b19532ec699.png";